//import "@babel/polyfill"
//import "es6-shim"
//import "es5-shim"
//import 'object.values'
//import jQuery from 'jquery' // Keep jQuery enqueued from WordPress to prevent Stripe payment Bug
import lozad from 'lozad'
import imagesLoaded from 'imagesloaded'
import Masonry from 'masonry-layout'
import Swiper from 'swiper'
//import Plyr from 'plyr'
import videojs from 'video.js'
import Cookies from 'js-cookie'

window.$ = window.jQuery = jQuery;

/*if (!('IntersectionObserver' in window)) {
    var scriptIntersectionObserver = document.createElement("script");
    scriptIntersectionObserver.src = "https://raw.githubusercontent.com/w3c/IntersectionObserver/master/polyfill/intersection-observer.js";
	document.getElementsByTagName('head')[0].appendChild(scriptIntersectionObserver);
	var scriptPlyr = document.createElement("script");
    scriptPlyr.src = "https://cdn.plyr.io/3.6.2/plyr.polyfilled.js";
    document.getElementsByTagName('head')[0].appendChild(scriptPlyr);
}*/


const observer = lozad('img.lazy, img.hover', {
    loaded: function(el) {
        el.classList.add('loaded');
    }
});
observer.observe();

$(function(){
	//lazyLoadInstance.update();
	/***********************************
	 MAIN
	***********************************/
	var mainHandler = {

		init: function(){
			
			this.closeAlert();
			this.mobileMenu();
			this.customForms();
			this.modalHandler();
			this.setFeaturedPlayer();
			this.setEditoPlayers();
			this.cookiesDisclaimer();
			this.alertStockForm();
			this.randomPushCollection();
			
		},

    alertStockForm : function(){
      if(jQuery('#form-alert-stock').length == 0)
        return;

      var form = jQuery('#form-alert-stock');
      var emailInput = form.find('input[name="email"]').first();
      var productIdInput = form.find('input[name="productid"]').first();
      var productId = productIdInput.val();
      var attributesInput = form.find('textarea[name="attributes"]').first();

      form.on('submit', function(e){
        e.preventDefault();
        jQuery('.reponse-form').remove();
        if(emailInput.val() != ""){
          form.addClass('loading');
          jQuery.ajax({
            url: theme_infos.wp_ajax_url,
            type: "POST",
            data: {
              'action' : 'alert_stock',
              'email' : emailInput.val(),
              'productid' : productId,
              'variation' : attributesInput.val()
            }
          }).done(function(response) {
            form.removeClass('loading');
            var json = jQuery.parseJSON(response);
            var txt = "";
            var classvalue = "";
            if(json.success){
              txt = json.success;
              classvalue = "success";
              emailInput.val('');
            }
            if(json.error){
              txt = json.error;
              classvalue = "error";
            }

            form.append('<div class="reponse-form '+classvalue+'">'+txt+'</div>');

          });
        }

        return false;
      });


    },

		closeAlert: function(){
			var $showAlert = Cookies.get('show-alert');

			// Cookies are strings only
			if( $showAlert !== 'false' ){
				$('.header--pre').removeClass('hidden');
				// Mobile Menu height calculation
				//$('.header--main-wrap').addClass('has-alert');
			}

			$('.btn--close-alert').on('click', function(){
				Cookies.set('show-alert', 'false', { expires: 1 });
				$('.header--pre').addClass('hidden');
				// Mobile Menu height calculation
				//$('.header--main-wrap').removeClass('has-alert');
			});
		},

		mobileMenu: function(){

            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);

            window.addEventListener('resize', () => {
                // We execute the same script as before
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            });

            // Update scroll
            var freezeVp = function(e) {
                e.preventDefault();
            };

            function stopBodyScrolling (bool) {
                if (bool === true) {
                    document.addEventListener("touchmove", freezeVp, {passive: false});
                } else {
                    document.removeEventListener("touchmove", freezeVp, {passive: false});
                }
			}

			var $navWrap = $('.header--main-wrap'),
				$viewportWidth = mainHandler.getViewportWidth(),
				$mobileBreakpoint = 1100;

			// Check resize
			window.addEventListener('resize', function () {
				$viewportWidth = mainHandler.getViewportWidth();
			}, false);

            // Mobile Nav
            $('.btn--toggle-menu').unbind('click').bind('click', function(e){

                /* Toggle Button */
                if( !$(this).hasClass('opened') ){
                    $(this).addClass('opened').removeClass('closed');
                } else {
                    $(this).addClass('closed').removeClass('opened');
                }

                /* Toggle Main menu */
                if( !$navWrap.hasClass('opened') ){
                    $navWrap.addClass('opened');
                    $('body').css({
                        'overflow': 'hidden'
                    });
                    //stopBodyScrolling(true);
                } else {
                    $navWrap.removeClass('opened');
                    $('body').css({
                        'overflow': 'auto'
                    });
                    //stopBodyScrolling(false);
                }

                /** Reset Menu & Submenus */
                closeMegamenus();

			});

			var megamenuItem = $('li.has-submenu .menu-item>.menu-item--label');

			/* Toggle megamenu */
            megamenuItem.unbind('click').bind('click', function (e) {

				if( $viewportWidth > $mobileBreakpoint ){
					return;
				}

				var $menuItem = $(e.target).parent(),
					$nextSubmenu = $menuItem.next('.megamenu'),
					$megamenuItem = $menuItem.closest('.has-submenu');

				if( $nextSubmenu.length !== 0 ){
					e.preventDefault();
				}

				/*var megamenuItemLabel = $(this),
					megamenuItemTarget = megamenuItemLabel.parent();*/

				if (!$megamenuItem.hasClass('opened')) {
					// Close others
					closeMegamenus();

					// Calculate height
                    /*var megamenuLength = $megamenuItem.find('.megamenu li').length;
                    $megamenuItem.find('.megamenu').css({
                        'max-height': megamenuLength * 64 + 40 + 'px'
					});*/

					// Open target megamenu
					$megamenuItem.addClass('opened');

                } else {
					closeMegamenus();
				}

			});

			function closeMegamenus(){
				$('.has-submenu').each(function(){
					$(this).removeClass('opened');
					$(this).find('.megamenu').css({
						'max-height': ''
					})
				})
			}

		},

		customForms: function(){

			/***********************************
			 CUSTOM CHECKBOXES
			***********************************/
			/** Check for previously checked checkboxes **/
			$('.input--field.checkbox').each(function(){

				var checkboxCustom = $(this).find('input[type="checkbox"]');

				if( checkboxCustom.is(':checked') ){
					$(this).closest('.checkbox').addClass('checked');
				} else {
					$(this).closest('.checkbox').removeClass('checked');
				}

				/** DISABLED CHECKBOX **/
				if( checkboxCustom.is(':disabled') ){
					$(this).closest('.checkbox').addClass('disabled');
				}

			});

			/** Apply styling on checkbox 'change' **/
			$(document).on('change', '.checkbox input[type="checkbox"]', function(){
				if( $(this).is(':checked') ){
					$(this).closest('.checkbox').addClass('checked');
				} else {
					$(this).closest('.checkbox').removeClass('checked');
				}
			});

			/***********************************
			 CUSTOM RADIO
			***********************************/
			/** Check for previously checked radio **/
			$('.input--field.radio').each(function(){

				var radioCustom = $(this).find('input[type="radio"]');

				if( radioCustom.is(':checked') ){
					$(this).closest('.radio').addClass('checked');
				} else {
					$(this).closest('.radio').removeClass('checked');
				}

				/** DISABLED CHECKBOX **/
				if( radioCustom.is(':disabled') ){
					$(this).closest('.radio').addClass('disabled');
				}

			});

			/** Apply styling on checkbox 'change' **/
			$(document).on('change', '.radio input[type="radio"]', function(){
				if( $(this).is(':checked') ){
					$(this).closest('.input--field-radiogroup').find('.radio').removeClass('checked');
					$(this).closest('.radio').addClass('checked');
				} else {
					$(this).closest('.input--field-radiogroup').find('.radio').removeClass('checked');
				}
			});

		},

		modalHandler: function(){

			$(document).on('click', '[data-modal]', function(e){
				e.preventDefault();
				var modal = $(this).attr('data-modal');
				$('#' + modal).addClass('active');
				stopBodyScrolling(true);
			});

			// Close Modal
			$('.btn--modal-close').on('click', function(){
				closeModal();
			});

			$(document).keyup(function(e) {
				if(e.key === "Escape") {
					closeModal();
				}
			});

			$(document).on('click touchstart', '.modal--overlay.active', function(e){
				if( !$(e.target).is('.modal--wrapper') && $('.modal--wrapper').has(e.target).length === 0 ){
					closeModal();
				}
			});

			function closeModal(){
				$('.modal--overlay').removeClass('active');
				stopBodyScrolling(false);
			}

			var $modal = $('.modal--content')

			var freezeVp = function(e) {
				if(!jQuery(e.target).is($modal) && jQuery($modal).has(e.target).length === 0 ){
					e.preventDefault();
				}
			};

			var noScroll = function(state) {
				if( state === true ){
					$('body').css({
						'overflow': 'hidden'
					});
				} else {
					$('body').css({
						'overflow': ''
					});
				}
			}

			function stopBodyScrolling (bool) {
				if (bool === true) {
					document.addEventListener("touchmove", freezeVp, {passive: false});
					document.addEventListener("scroll", noScroll(true));
				} else {
					document.removeEventListener("touchmove", freezeVp, {passive: false});
					document.addEventListener("scroll", noScroll(false));
				}
			}


		},

		instagramDesktop: function(){

			// Show only 5 instagram Pictures on Desktop
			// Problem on resize

		},

		setFeaturedPlayer: function(){
			// Alway Fluid
			let videoPlayer = document.querySelectorAll('.section--featured-collection.video .video-js');
			if( typeof(videoPlayer) != 'undefined' && videoPlayer != null ){
				Array.from(videoPlayer).forEach(function(playerEl, index){

					var player = new videojs(playerEl,{
						responsive: true,
						fluid: true
					});
					playerEl.dataset.playerId = index;
				});
			}
		},

		setEditoPlayers: function(){
			

			setPlayers();
			setPlayersRatio();

			window.addEventListener('resize', function () {
				setPlayersRatio()
			}, false);
			
			function setPlayers(){
				
				let videoPlayersWrap = document.querySelectorAll('.section--featured-edito .video--wrap');
				let videoPlayers = document.querySelectorAll('.section--featured-edito .video-js');
				
				if( typeof(videoPlayers) != 'undefined' && videoPlayers != null ){
					Array.from(videoPlayers).forEach(function(playerEl, index){
						var player = new videojs(playerEl,{
							responsive: true
						});
						playerEl.dataset.playerId = index;
					});
				}
			}

			function setPlayersRatio(){
				
				let videoPlayersWrap = document.querySelectorAll('.section--featured-edito .video--wrap');
				let players = videojs.getAllPlayers();
				let vw = mainHandler.getViewportWidth();

				// Exclude Featured Player from VideoJS array
				let featuredPlayerID = 'player-featured';
				players = players.filter(function( obj ) {
					return obj.id_ !== featuredPlayerID;
				});

				if( vw <= 1024 ){
					Array.from(videoPlayersWrap).forEach(function(playerWrapEl, index){
						playerWrapEl.classList.remove('video-fill');
					});
					Array.from(players).forEach(function(playerEl, index){
						playerEl.fill(false);
						playerEl.fluid(true);
					});
				} else {
					Array.from(videoPlayersWrap).forEach(function(playerWrapEl, index){
						playerWrapEl.classList.add('video-fill');
					});

					// Set Video Ratio
					Array.from(players).forEach(function(playerEl, index){
						playerEl.fill(true);
						playerEl.fluid(false);
					});
				}

			}
		},

		randomPushCollection: function(){
			
			let pushsIsVideo = document.querySelector('.section--featured-collection.video');
			if( typeof(pushsIsVideo) != 'undefined' && pushsIsVideo != null){
				return;
			}

			let pushCollection = document.querySelector('.push--collection');
			if( typeof(pushCollection) != 'undefined' && pushCollection != null){
				let pushCollectionImages = pushCollection.querySelectorAll('.push--collection-thumb picture');				
				let arrayCount = [];

				Array.from(pushCollectionImages).forEach(function(picture, index){
					arrayCount.push(index);
				});

				let randomIndex = arrayCount[Math.floor(Math.random() * arrayCount.length)];
				pushCollectionImages[randomIndex].querySelector('img').classList.remove('hidden');
			} else {
				return;
			}

		},

		cookiesDisclaimer: function(){

			if( Cookies.get('cookies-accepted') !== 'yes' ){
				$('.cookies-disclaimer').removeClass('cookies-accepted');
			}

			$('.btn--close-cookies').on('click', function(e){
				e.preventDefault();
                $('.cookies-disclaimer').addClass('cookies-accepted');
				Cookies.set('cookies-accepted', 'yes', { expires: 7 });
			});

		},

		getViewportWidth: function(){
			var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
			return viewportWidth;
		}

	};
	mainHandler.init();


	/***********************************
	 MAIN
	***********************************/
	var productHandler = {

		init: function(){

			this.productGallery();
			this.productVariations();
			this.productTabs();

		},

		productGallery: function(){

			/** Init Videos **/

			//var productPlayers = Plyr.setup('.product--gallery-slide .video-player');
			let id = 0;
			let videos = document.querySelectorAll('.product--gallery-slide .video-js');
			//console.log(videos);
			videos.forEach(function(element, index){
				var productPlayers = new videojs(element,{
					responsive: true,
					fill: true
				});
				element.dataset.playerId = index;
				//id++;
			})
			

			/*$('.product--gallery-slide.video').each(function(){
				$(this).find('.video-player').attr('data-player-id', id);
				id++;
			});*/

			/** SWIPER **/
			var $productGallery = new Swiper('.product--gallery-container', {
				speed: 650,
				slidesPerView: 1,
				slidesPerGroup: 1,
				loop: true,
				//preloadImages: false,
				updateOnImagesReady: false,
				wrapperClass: 'product--gallery-wrapper',
				slideClass: 'product--gallery-slide',
				slideActiveClass: 'active',
				slidePrevClass: 'prev',
				slideDuplicatePrevClass: 'duplicate-prev',
				slideNextClass: 'next',
				slideDuplicateNextClass: 'duplicate-next',
				on: {
					slideChangeTransitionEnd: function(){
						var currentSlide = $('.product--gallery-slide.active');

						$('.video-js').each(function () {
							var playerID = $(this).attr('id')
							videojs.getPlayer(playerID).pause();
						});

						if ( currentSlide.hasClass('video') ){
							var playerID = currentSlide.find('.video-js').attr('id');
							var player = videojs.getPlayer(playerID);
							player.play();
						}

					}
				}
			});


			// Hack for Lazy Loading
			setTimeout(function(){
				$productGallery.update();
			}, 400);

			/** Thumbs Swiper **/
			var $productThumbs = new Swiper('.product--thumbnails-container', {
				speed: 650,
				direction: 'vertical',
				//slidesPerView: 5,
				slidesPerView: 'auto',
				//slidesPerGroup: 5,
				//centeredSlides: true,
				spaceBetween: 35,
				mousewheel: true,
				//freeModeSticky: true,
				//freeMode: true,
				loop: false,
				wrapperClass: 'product--thumbnails-wrapper',
				slideClass: 'product-thumb',
				slideActiveClass: 'current',
				slidePrevClass: 'prev',
				slideDuplicatePrevClass: 'duplicate-prev',
				slideNextClass: 'next',
				slideDuplicateNextClass: 'duplicate-next'
			});

			/** Thumbs Navigation **/
			var $thumb = $('.product-thumb');
			$thumb.on('click', function(){
				var $index = $(this).index() + 1;
				$('.product-thumb').removeClass('active');
				$(this).addClass('active');
				$productGallery.slideTo($index)
			});

		},

		productVariations: function(){

			/***********************************
			 COLOR LABEL
			***********************************/
			/** Update Color label when already checked **/
			var $colorsChoices = $('.product--variations-block.colors'),
				$label = $colorsChoices.find('.input--field.radio.color.checked').text();
				$colorsChoices.find('.product--variations-label').html($label);

			/** Update Color label on Radio change **/
			$(document).on('change', '.radio.color input[type="radio"]', function(){
				if( $(this).is(':checked') ){
					var $label = $(this).parent().text();
					$(this).closest('.input--field-radiogroup').parent().find('.product--variations-label').html($label)
				}
			});

		},

		productTabs: function(){

			var $buttons = $('.btn--tab'),
				$tabsContent = $('.tab--content'),
				$tabs = $('.tab--content-inner');

				//$(this).outerHeight(true) + $(this).find('.btn--tab').outerHeight(true) + 20
			// Make sure images are loaded
			imagesLoaded('.tab--content-inner', function() {
				// Prepare Tabs
				$tabsContent.each(function(){
					var $height = $(this).find('.btn--tab').outerHeight(true) + $(this).find('.tab--content-inner').outerHeight(true) + 10;
					$(this).find('.tab--content-inner').attr('data-height', $height);
					$(this).find('.tab--content-inner').css({
						'max-height': 0
					});
				});

				// Show first Tab
				var $firstTab = $buttons.first().attr('data-tab');
				showTab($firstTab);
			});

			// Tabs switch
			$buttons.on('click', function(){
				var $button = $(this),
					$requestedTab = $button.attr('data-tab');
					
				if ($button.hasClass('active')){
					closeTabs();
				} else {
					showTab($requestedTab)
				}
			});

			// Show Tab function
			function showTab(id){
				var $tabHeight = $('#tab-'+ id +' .tab--content-inner').attr('data-height');

				closeTabs();
				
				$buttons.filter('[data-tab="'+ id + '"]').addClass('active');

				$('#tab-'+ id +' .tab--content-inner').addClass('expanded').css({
					'max-height': $tabHeight + 'px'
				});

				$('#tab-'+ id).css({
					'height': $tabHeight + 'px'
				});
			}

			function closeTabs(){
				$buttons.removeClass('active');
				$tabs.removeClass('expanded');
				$tabsContent.css({
					'height': ''
				});
			}

		}

	};
	if($('#product').length){
		productHandler.init();
	}


	/***********************************
	 COLLECTION (LOOKBOOK)
	***********************************/
	var lookbookHandler = {

		init: function(){

			// this.setLookbookGrid();

		},

		setLookbookGrid: function(){

			// init Masonry
			var $grid = new Masonry('.section--lookbook-wrap', {
				//columnWidth: '.grid-sizer',
				//columnWidth: 200,
				//fitWidth: true,
				//gutter: '.gutter-sizer',
				itemSelector: '.push--lookbookItem',
				percentPosition: true
			});
			// layout Masonry after each image loads
			imagesLoaded('.section--lookbook-wrap', function() {
				$grid.layout();
			});


		}

	};
	if($('#lookbook').length){
		lookbookHandler.init();
	}


	/***********************************
	 JOURNAL
	***********************************/
	var journalHandler = {

		init: function(){

			this.setJournalGrid();

		},

		setJournalGrid: function(){

			// init Masonry
			var $grid = new Masonry('.section--journal-wrap', {
				//columnWidth: '.grid-sizer',
				//columnWidth: 200,
				//gutter: '.gutter-sizer',
				itemSelector: '.push--journal',
				percentPosition: true
			});
			// layout Masonry after each image loads
			imagesLoaded('.section--journal-wrap', function() {
				$grid.layout();
			});
			/*$grid.imagesLoaded().progress( function() {
				$grid.masonry('layout');
			});*/


		}

	};
	if($('#journal').length){
		journalHandler.init();
	}


	/**************************************************
	 WOOCOMMERCE
	**************************************************/
	var wooCommerceHandler = {
		init: function(){
			this.autoupdateCart();
			//this.checkout();
		},

		autoupdateCart: function(){
			var timeout;

			$('.woocommerce').on('change', 'input.qty', function(){

				if ( timeout !== undefined ) {
					clearTimeout( timeout );
				}

				timeout = setTimeout(function() {
					$("[name='update_cart']").trigger("click");
				}, 1000 ); // 1 second delay, half a second (500) seems comfortable too

			});

		},

		/*checkout: function(){
			$('.checkout--showlogin').on('click', function(){
				$('.checkout--login').toggleClass('hidden');
			});
		}*/
	}
	if($('body.woocommerce-js').length){
		wooCommerceHandler.init();
	}

});
